import axios from 'axios'
import ElementUI, { Drawer } from 'element-ui'
import VueCookies from 'vue-cookies'
import common from './common'
// import store from '../../store'
import router from '../../router'
let reqUrl = window.location.origin
if (reqUrl.indexOf(':8080') != -1) {
  // reqUrl = "http://10.50.10.20:9011";
  // reqUrl = 'https://itsm-corp2.cngb.org'

  // reqUrl = 'https://10.50.10.20/'
  
  reqUrl = 'http://127.0.0.1:8001/'
  // https://itsm-corp1.cngb.org/cmpapi/getuserallrights
}
let instance = axios.create({ baseURL: reqUrl })
instance.interceptors.response.use(
  function (response) {
    if (response.data.code == 1000) {
      VueCookies.set('token', '')
      VueCookies.set('userInfo', '')
      localStorage.setItem('userPhoto', '')
      common.formatLoginUrl(router.currentRoute)
      return false
    }
    return response
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)
const utilits = {
  post (url, params) {
    return instance.post(url, params)
  },
  get (url, params) {
    return instance.get(url, {
      params
    })
  },
  put (url, params) {
    return instance.put(url, params)
  },
  delete (url, params) {
    return instance.delete(url, {
      params
    })
  },
  httpRequest (method, url, params, callback, isblob = false, isdebugmsg = true) {
    // 给所有请求添加Authorization
    let token = VueCookies.get('token')
    if (token) {
      instance.defaults.headers.Authorization = token
    } else {
      delete instance.defaults.headers.Authorization
    }
    // 如果是下载文件responseType类型改为blob
    if (isblob) {
      instance.defaults.responseType = 'blob'
    } else {
      instance.defaults.responseType = 'json'
    }
    let _this = this
    return new Promise((resolve, reject) => {
      let cb = () => {
        method(url, params)
          .then(response => {
            const resData = response.data
            if ((resData.realname && !resData.code) || isblob) {
              resolve(response)
            } else {
              if (resData.code == 0) {
                resolve(response)
              }
              //  else if (url.indexOf("cmpapi/getuserallrights") == -1) {
              //     ElementUI.Message["error"](resData.debugmsg);
              //     resolve(response);
              // }
              else {
                if (resData.debugmsg && isdebugmsg) {
                  ElementUI.Message['error'](resData.debugmsg)
                }
                resolve(response)
              }
            }
          })
          .catch(err => {
            return reject({ code: -100 })
          })
      }
      cb()
    })
  },
  onUploadProgress (progressEvent) {},
  onDownloadProgress (progressEvent) {},
  request (url, method, data) {
    let token = VueCookies.get('token')
    axios({
      method: 'post',
      url: reqUrl + url,
      data,
      responseType: 'blob',
      headers: {
        Authorization: token
      }
    }).then(response => {
      common.downloadFile(response)
    })
  },
  requestAll (arr) {
    return axios.all(arr).then(
      axios.spread(function (acct, perms) {
        // 两个请求现在都执行完成
      })
    )
  }
}
export default utilits



// WEBPACK FOOTER //
// ./src/assets/utilits/request.js